import templateUrl from './icd-payout-policy-list-container.component.html';

export const IcdPayoutPolicyListContainerComponent = {
    controller: IcdPayoutPolicyListContainerController,
    controllerAs: "vm",
    templateUrl,
    bindings: {
        isAdminView: "<"
    }
}

function IcdPayoutPolicyListContainerController($q, utilityService, productsService,
    productLinesService, icdCorporationService) {
    'ngInject';
    const vm = this;
    vm.divisions;
    vm.products;
    vm.productLines;
    vm.filters = {};
    vm.$onInit = onInit;

    function onInit() {
        activate();
    }

    function activate() {

        const dataLoaded = loadInitialData()
            .then(function () {
                vm.filters.icdCorporation = vm.icdCorporations.length > 0 ? vm.icdCorporations[0] : null;

            })
        utilityService.showLoadingUntilResolved(
            utilityService.alertOnError(dataLoaded, "Initial load failed"));
    }

    function loadInitialData() {


        const getProducts = productsService.retrieveProducts();
        const getProductLines = productLinesService.retrieveProductLines();
        const getCorporations = icdCorporationService.retrieveIcdCorporationsByModuleAdmin("Payout");


        return $q.all([getProducts, getProductLines, getCorporations])
            .then(function (v) {
                vm.products = v[0];
                vm.productLines = v[1];
                vm.icdCorporations = v[2];
                vm.icdCorporations
                    .sort(function (a, b) {
                        if (a.Owner < b.Owner) {
                            return -1;
                        } else if (a.Owner > b.Owner) {
                            return 1;
                        }
                        return a.ClientName < b.ClientName ? -1 : 1;
                    })
                    .forEach(formatIcdCorporation);

            });
    }


    function formatIcdCorporation(icdCorporation) {
        icdCorporation.OwnerClientName = icdCorporation.Owner + " - " + icdCorporation.ClientName;
    }


}
